import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type StoreSearchFragmentFragment = { __typename?: 'StoreSearchResult', id: string, name?: string | null, store?: { __typename?: 'Store', id: string, brand_id?: string | null, name?: string | null, published?: boolean | null, coming_soon?: boolean | null, available_soon: boolean, permanently_removed?: boolean | null, banner?: string | null, revenue_tier?: Types.StoreTier | null, tier?: Types.StoreTier | null, contracted_date?: string | null, onboarded_date?: string | null, contract_end_date?: string | null, inkassokennzeichen?: boolean | null, address?: { __typename?: 'Address', streetname?: string | null, streetno?: string | null, zip?: string | null, city?: string | null } | null, invoice_collection?: { __typename?: 'InvoiceCollection', id: string, name: string } | null } | null, brand?: { __typename?: 'Brand', id: string, name?: string | null, permanently_removed?: boolean | null, logo?: string | null } | null };

export type StoreSearchBrandFragment = { __typename?: 'Brand', id: string, name?: string | null, permanently_removed?: boolean | null, logo?: string | null };

export type StoreSearchStoreFragment = { __typename?: 'Store', id: string, brand_id?: string | null, name?: string | null, published?: boolean | null, coming_soon?: boolean | null, available_soon: boolean, permanently_removed?: boolean | null, banner?: string | null, revenue_tier?: Types.StoreTier | null, tier?: Types.StoreTier | null, contracted_date?: string | null, onboarded_date?: string | null, contract_end_date?: string | null, inkassokennzeichen?: boolean | null, address?: { __typename?: 'Address', streetname?: string | null, streetno?: string | null, zip?: string | null, city?: string | null } | null, invoice_collection?: { __typename?: 'InvoiceCollection', id: string, name: string } | null };

export const StoreSearchStoreFragmentDoc = gql`
    fragment StoreSearchStore on Store {
  id
  brand_id
  name
  published
  coming_soon
  available_soon
  permanently_removed
  banner
  address {
    streetname
    streetno
    zip
    city
  }
  revenue_tier
  tier
  contracted_date
  onboarded_date
  contract_end_date
  inkassokennzeichen
  invoice_collection {
    id
    name
  }
}
    `;
export const StoreSearchBrandFragmentDoc = gql`
    fragment StoreSearchBrand on Brand {
  id
  name
  permanently_removed
  logo
}
    `;
export const StoreSearchFragmentFragmentDoc = gql`
    fragment StoreSearchFragment on StoreSearchResult {
  id
  name
  store {
    ...StoreSearchStore
  }
  brand {
    ...StoreSearchBrand
  }
}
    ${StoreSearchStoreFragmentDoc}
${StoreSearchBrandFragmentDoc}`;